/*
 * COPYRIGHT:     Copyright © 2023 Xplorie LLC
 * Warning:       This product is protected by United States and international copyright laws.
 *                Unauthorized use or duplication of this software, in whole or in part, is prohibited.
 */

export const FUTURE_SEASONS_MESSAGE =
  'Are you sure you want to change the Program type to SmartHost Standalone? The Activities and Rates of the future Seasons will be removed!'
